import gql from 'graphql-tag';

export default gql`
  mutation disableMobileAccess($channelId: UUID!, $userIds: [UUID!]!) {
    disableMobileAccess(channelId: $channelId, userIds: $userIds)
  }
`;
